import React from "react";
import PropTypes from "prop-types";

export const BlogCollectionTile = ({title, url, imageJpgUrl, imageWebpUrl}) => {
    return (
        <div className="blog-collection-tile">
            <div className="lh0">
                {imageJpgUrl || imageWebpUrl ? (
                    <picture>
                        <source srcSet={imageWebpUrl} type='image/webp'/>
                        <img
                            className="blog-collection-tile-img"
                            src={imageJpgUrl}
                            alt={title}
                            width={391}
                            height={460}
                            loading={"lazy"}
                        />
                    </picture>
                ) : (
                    <div className="blog-collection-tile-fake-img"></div>
                )}
            </div>
            <h4>
                <a href={url} className="blog-collection-tile-title stretched-link">
                    {title}
                </a>
            </h4>
        </div>
  );
};

BlogCollectionTile.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
};

BlogCollectionTile.defaultProps = {
  title: null,
  url: null,
  image: null,
};
